import { action, observable } from 'mobx'
import { MyDocumentRequest } from '../requests/MyDocumentRequest'

class MyDocumentStore {
  @observable myDocumentList = []
  @observable sharedDocumentList = []
  @observable totalCount = 0
  @observable totalPage = 0
  @observable breadcrumb = []
  @observable currentParentId = ''
  @observable sharedTotalCount = 0
  @observable sharedTotalPage = 0

  @observable queryParams = {
    page: 0,
    size: 10,
    type: '',
  }

  @observable sharedQueryParams = {
    page: 0,
    size: 10,
    keyword: '',
  }

  @action clearQueryParams = () => {
    this.queryParams = {
      page: 0,
      size: 10,
      type: '',
    }
  }

  @action setQueryParams = payload => {
    this.queryParams = {
      ...this.queryParams,
      ...payload,
      size: payload.size ? parseInt(payload.size) : 10,
      page: payload.page ? parseInt(payload.page) : 0,
    }
  }

  @action setSharedQueryParams = payload => {
    this.sharedQueryParams = {
      ...this.sharedQueryParams,
      ...payload,
      size: payload.size ? parseInt(payload.size) : 10,
      page: payload.page ? parseInt(payload.page) : 0,
    }
  }

  @action setCurrentParentId = id => {
    this.currentParentId = id || ''
  }

  @action getList = () => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.getList({
        ...this.queryParams,
        id: this.currentParentId,
      })
        .then(response => {
          this.myDocumentList = response.data?.data || []
          this.totalCount = response.data?.totalCount || response.data?.total_count || 0
          this.totalPage = response.data?.totalPage || response.data?.total_page || 0
          this.breadcrumb = response.data?.breadcrumb || []
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getSharedList = () => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.getSharedList({
        ...this.sharedQueryParams,
      })
        .then(response => {
          this.sharedDocumentList = response.data?.data || []
          this.sharedTotalCount = response.data?.totalCount || response.data?.total_count || 0
          this.sharedTotalPage = response.data?.totalPage || response.data?.total_page || 0
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createDocument = body => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.create(body)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  @action renameDocument = (id, body) => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.rename(id, body)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  @action moveDocument = (srcId, desId) => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.move(srcId, desId)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  @action shareDocument = (id, body) => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.share(id, body)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  @action publishDocument = (id, body) => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.publish(id, body)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  @action deleteDocument = id => {
    return new Promise((resolve, reject) => {
      MyDocumentRequest.delete(id)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
}

export default new MyDocumentStore()
